import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  baseQuery: rtkBaseQuery('/auth/Roles'),
  endpoints: (builder) => ({
    addRoleToUser: builder.mutation({
      query: (body) => ({
        url: '/AddUserToRole',
        method: 'POST',
        body,
      }),
    }),
    removeRoleFromUser: builder.mutation({
      query: (body) => ({
        url: '/RemoveUserFromRole',
        method: 'POST',
        body,
      }),
    }),
    removeRole: builder.mutation({
      query: ({ id }) => ({
        url: `/Delete?roleId=${id}`,
        method: 'DELETE',
      }),
    }),
    createRole: builder.mutation({
      query: ({ name }) => ({
        url: `/Create?roleName=${name}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useAddRoleToUserMutation,
  useRemoveRoleFromUserMutation,
  useRemoveRoleMutation,
  useCreateRoleMutation,
} = rolesApi;
